import useAuth from "./useAuth";
import { isARMSTRONG, isATLAS, isPNC } from "../utils/inventoryRequests";
import { getDestinationInfo, getOriginInfo } from "../constants/fields";
import useAllFields from "./useAllFields";
import { useProject } from "src/contexts/project";

const defaultSetting =
  "identifiers,descriptive_info,origin_info,destination_info,warehouse_info,electrical_info,plumbing_info,mechanical_info,inventory_items,inventory_request,shopping_cart";

export default function useFields() {
  const { user } = useAuth();
  const currentProject = useProject();
  const { company } = user;
  const { settings } = user.company;
  const columns = (company.settingsConfig || defaultSetting).split(",");
  const settingsConfig =
    isPNC || isATLAS || isARMSTRONG
      ? columns.filter(v => !["plumbing_info", "mechanical_info"].includes(v))
      : columns;
  const allFields = useAllFields();
  const { identifiers, warehouseInfo, descriptiveInfo } = allFields;
  const storageEnabled = currentProject?.storageEnabled;
  const onsiteInventoryCapture = currentProject?.settings?.onsite_inventory_capture;

  const fields = [
    {
      enabled: settingsConfig.includes("identifiers"),
      label: "Identifiers",
      list: identifiers,
    },
    {
      enabled: settingsConfig.includes("descriptive_info"),
      label: "Descriptive",
      list: descriptiveInfo,
    },
    {
      enabled: settingsConfig.includes("warehouse_info") && settings.inventory_tracking && !onsiteInventoryCapture,
      label: "Storage",
      list: warehouseInfo,
    },
    {
      enabled: settingsConfig.includes("origin_info") && !storageEnabled,
      label: "Origin",
      list: getOriginInfo(settings),
    },
    {
      enabled: settingsConfig.includes("destination_info") && !storageEnabled,
      label: "Destination",
      list: getDestinationInfo(settings),
    },
  ];

  return fields.filter(v => v.enabled);
}
